"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const facility_dto_1 = require("../../../../dtos/facility-dto");
const i0 = require("@angular/core");
const i1 = require("@angular/common");
const i2 = require("@angular/material/chips");
const i3 = require("@angular/material/tooltip");
const i4 = require("../../../../../common/directives/dnaR-popover/dnaR-popover.directive");
function FacilityDetailsViewTabComponent_label_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label");
    i0.ɵɵtext(1, "Aged care service name");
    i0.ɵɵelementEnd();
} }
function FacilityDetailsViewTabComponent_label_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label");
    i0.ɵɵtext(1, "Facility name");
    i0.ɵɵelementEnd();
} }
function FacilityDetailsViewTabComponent_div_10_div_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelementStart(1, "div", 4);
    i0.ɵɵelement(2, "i", 5);
    i0.ɵɵelementStart(3, "label");
    i0.ɵɵtext(4, "Region");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 45);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", ctx_r6.facility.region == null ? null : ctx_r6.facility.region.name, " ");
} }
function FacilityDetailsViewTabComponent_div_10_ng_template_41_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 46);
    i0.ɵɵelementStart(1, "h3", 47);
    i0.ɵɵtext(2, " Modified Monash Model (MMM)");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 48);
    i0.ɵɵtext(4, "The Modified Monash Model (MMM) of remoteness is used to calculate the fixed funding component; Base Care Tariff (BCT)");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function FacilityDetailsViewTabComponent_div_10_span_47_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 49);
    i0.ɵɵtext(1, "To find your MMM category, type your facility's address into the ");
    i0.ɵɵelementStart(2, "a", 50);
    i0.ɵɵtext(3, "Health Workforce Locator");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4, " tool and check the 2019 checkbox.");
    i0.ɵɵelementEnd();
} }
function FacilityDetailsViewTabComponent_div_10_span_48_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 49);
    i0.ɵɵtext(1, "Classification retrieved from Services Australia.");
    i0.ɵɵelementEnd();
} }
function FacilityDetailsViewTabComponent_div_10_ng_template_57_tr_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td", 53);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "number");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td");
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const supportedResidentsThreshold_r19 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind2(3, 2, supportedResidentsThreshold_r19.value, 0), "% ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(6, 5, supportedResidentsThreshold_r19.startDate, "dd-MMM-yyyy"));
} }
function FacilityDetailsViewTabComponent_div_10_ng_template_57_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 51);
    i0.ɵɵelementStart(1, "table", 52);
    i0.ɵɵelementStart(2, "thead");
    i0.ɵɵelementStart(3, "tr");
    i0.ɵɵelementStart(4, "th", 53);
    i0.ɵɵtext(5, "Percentage");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "th");
    i0.ɵɵtext(7, "Effective date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "tbody");
    i0.ɵɵtemplate(9, FacilityDetailsViewTabComponent_div_10_ng_template_57_tr_9_Template, 7, 8, "tr", 54);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(9);
    i0.ɵɵproperty("ngForOf", ctx_r12.facility.supportedResidentsThresholdList);
} }
function FacilityDetailsViewTabComponent_div_10_span_60_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 55);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("From ", i0.ɵɵpipeBind2(2, 1, ctx_r13.supportedResidentsThresholdEffectiveDate, "dd-MMM-yyyy"), "");
} }
function FacilityDetailsViewTabComponent_div_10_ng_template_69_tr_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td", 53);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "number");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td");
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const registeredBeds_r21 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(3, 2, registeredBeds_r21.value, 0));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(6, 5, registeredBeds_r21.startDate, "dd-MMM-yyyy"));
} }
function FacilityDetailsViewTabComponent_div_10_ng_template_69_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 51);
    i0.ɵɵelementStart(1, "table", 52);
    i0.ɵɵelementStart(2, "thead");
    i0.ɵɵelementStart(3, "tr");
    i0.ɵɵelementStart(4, "th", 53);
    i0.ɵɵtext(5, "Amount");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "th");
    i0.ɵɵtext(7, "Effective date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "tbody");
    i0.ɵɵtemplate(9, FacilityDetailsViewTabComponent_div_10_ng_template_69_tr_9_Template, 7, 8, "tr", 54);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(9);
    i0.ɵɵproperty("ngForOf", ctx_r15.facility.registeredBedsList);
} }
function FacilityDetailsViewTabComponent_div_10_span_72_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 56);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("From ", i0.ɵɵpipeBind2(2, 1, ctx_r16.registeredBedsEffectiveDate, "dd-MMM-yyyy"), "");
} }
function FacilityDetailsViewTabComponent_div_10_div_73_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 46);
    i0.ɵɵelementStart(1, "div", 48);
    i0.ɵɵtext(2, "Value must align to the Department of Health published matrix");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function FacilityDetailsViewTabComponent_div_10_div_73_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelementStart(1, "div", 41);
    i0.ɵɵelementStart(2, "label", 57);
    i0.ɵɵtext(3, "Care minutes supplement");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "a", 58);
    i0.ɵɵtemplate(5, FacilityDetailsViewTabComponent_div_10_div_73_ng_template_5_Template, 3, 0, "ng-template", null, 59, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 60);
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "currency");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r22 = i0.ɵɵreference(6);
    const ctx_r17 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("dnaRPopover", _r22);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(9, 2, ctx_r17.facility.careMinutesSupplement, "$"), " ");
} }
function FacilityDetailsViewTabComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 3);
    i0.ɵɵelementStart(2, "div", 4);
    i0.ɵɵelement(3, "i", 5);
    i0.ɵɵelementStart(4, "label");
    i0.ɵɵtext(5, "NAPS ID");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "a", 24);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 25);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 3);
    i0.ɵɵelementStart(10, "div", 4);
    i0.ɵɵelement(11, "i", 5);
    i0.ɵɵelementStart(12, "label");
    i0.ɵɵtext(13, "EDI minor ID");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 26);
    i0.ɵɵtext(15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "div", 3);
    i0.ɵɵelementStart(17, "div", 4);
    i0.ɵɵelementStart(18, "label");
    i0.ɵɵtext(19, "ARCH ID");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "div", 27);
    i0.ɵɵtext(21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(22, FacilityDetailsViewTabComponent_div_10_div_22_Template, 7, 1, "div", 28);
    i0.ɵɵelementStart(23, "div", 3);
    i0.ɵɵelementStart(24, "div", 4);
    i0.ɵɵelementStart(25, "h2", 14);
    i0.ɵɵtext(26, "Funding details");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(27, "div", 3);
    i0.ɵɵelementStart(28, "div", 4);
    i0.ɵɵelementStart(29, "label");
    i0.ɵɵtext(30, "Significantly refurbished or newly built");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(31, "div", 29);
    i0.ɵɵelementStart(32, "div", 30);
    i0.ɵɵtext(33);
    i0.ɵɵpipe(34, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(35, "div", 3);
    i0.ɵɵelementStart(36, "div", 4);
    i0.ɵɵelement(37, "i", 5);
    i0.ɵɵelementStart(38, "label");
    i0.ɵɵtext(39, "MMM facility classification");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(40, "a", 31);
    i0.ɵɵtemplate(41, FacilityDetailsViewTabComponent_div_10_ng_template_41_Template, 5, 0, "ng-template", null, 32, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(43, "div", 33);
    i0.ɵɵtext(44);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(45, "div", 3);
    i0.ɵɵelementStart(46, "div", 34);
    i0.ɵɵtemplate(47, FacilityDetailsViewTabComponent_div_10_span_47_Template, 5, 0, "span", 35);
    i0.ɵɵtemplate(48, FacilityDetailsViewTabComponent_div_10_span_48_Template, 2, 0, "span", 35);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(49, "div", 3);
    i0.ɵɵelementStart(50, "div", 4);
    i0.ɵɵelement(51, "i", 5);
    i0.ɵɵelementStart(52, "label");
    i0.ɵɵtext(53, "Supported resident threshold");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(54, "div", 36);
    i0.ɵɵelementStart(55, "a", 37);
    i0.ɵɵtext(56);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(57, FacilityDetailsViewTabComponent_div_10_ng_template_57_Template, 10, 1, "ng-template", null, 38, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(59, "div", 39);
    i0.ɵɵtemplate(60, FacilityDetailsViewTabComponent_div_10_span_60_Template, 3, 4, "span", 40);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(61, "div", 3);
    i0.ɵɵelementStart(62, "div", 41);
    i0.ɵɵelement(63, "i", 5);
    i0.ɵɵelementStart(64, "label");
    i0.ɵɵtext(65, "Registered beds");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(66, "div", 36);
    i0.ɵɵelementStart(67, "a", 42);
    i0.ɵɵtext(68);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(69, FacilityDetailsViewTabComponent_div_10_ng_template_69_Template, 10, 1, "ng-template", null, 43, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(71, "div", 39);
    i0.ɵɵtemplate(72, FacilityDetailsViewTabComponent_div_10_span_72_Template, 3, 4, "span", 44);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(73, FacilityDetailsViewTabComponent_div_10_div_73_Template, 10, 5, "div", 28);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r7 = i0.ɵɵreference(42);
    const _r11 = i0.ɵɵreference(58);
    const _r14 = i0.ɵɵreference(70);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("matTooltipPosition", "after");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.facility.napsId, " ");
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.facility.ediMinorCustomerID, " ");
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.facility.archId, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.facility.region);
    i0.ɵɵadvance(11);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(34, 17, ctx_r2.facility.significantlyRefurbishedDateUtc, "dd-MMM-yyyy"), " ");
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("dnaRPopover", _r7);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.facility.anaccFixedComponent == null ? null : ctx_r2.facility.anaccFixedComponent.facilityMMMClassificationText, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r2.facility.facilityMMMClassificationIsActual);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.facility.facilityMMMClassificationIsActual);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("dnaRPopover", _r11);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r2.supportedResidentsThreshold, "%");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r2.supportedResidentsThresholdEffectiveDate);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("dnaRPopover", _r14);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r2.registeredBeds);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r2.registeredBedsEffectiveDate);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.facility.facilityMMMClassification === "StandardMMM1");
} }
function FacilityDetailsViewTabComponent_div_11_ng_template_9_tr_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td", 53);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "number");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td");
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const numberOfUnits_r28 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(3, 2, numberOfUnits_r28.value, 0));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(6, 5, numberOfUnits_r28.startDate, "dd-MMM-yyyy"));
} }
function FacilityDetailsViewTabComponent_div_11_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 51);
    i0.ɵɵelementStart(1, "table", 52);
    i0.ɵɵelementStart(2, "thead");
    i0.ɵɵelementStart(3, "tr");
    i0.ɵɵelementStart(4, "th", 53);
    i0.ɵɵtext(5, "Amount");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "th");
    i0.ɵɵtext(7, "Effective date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "tbody");
    i0.ɵɵtemplate(9, FacilityDetailsViewTabComponent_div_11_ng_template_9_tr_9_Template, 7, 8, "tr", 54);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r25 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(9);
    i0.ɵɵproperty("ngForOf", ctx_r25.facility.numberOfUnitsList);
} }
function FacilityDetailsViewTabComponent_div_11_span_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 64);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r26 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("From ", i0.ɵɵpipeBind2(2, 1, ctx_r26.numberOfUnitsEffectiveDate, "dd-MMM-yyyy"), "");
} }
function FacilityDetailsViewTabComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 3);
    i0.ɵɵelementStart(2, "div", 41);
    i0.ɵɵelement(3, "i", 5);
    i0.ɵɵelementStart(4, "label");
    i0.ɵɵtext(5, "Number of units");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 36);
    i0.ɵɵelementStart(7, "a", 61);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, FacilityDetailsViewTabComponent_div_11_ng_template_9_Template, 10, 1, "ng-template", null, 62, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 39);
    i0.ɵɵtemplate(12, FacilityDetailsViewTabComponent_div_11_span_12_Template, 3, 4, "span", 63);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r24 = i0.ɵɵreference(10);
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("dnaRPopover", _r24);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r3.numberOfUnits);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r3.numberOfUnitsEffectiveDate);
} }
function FacilityDetailsViewTabComponent_mat_chip_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-chip", 65);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const facilityLocation_r29 = ctx.$implicit;
    i0.ɵɵproperty("selectable", true)("removable", false);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", facilityLocation_r29.name, " ");
} }
/**
 * Displays the facility details view tab.
 */
class FacilityDetailsViewTabComponent {
    /**
     * Initializes a new instance of the @see FacilityDetailsViewTabComponent class.
     */
    constructor() {
        /**
         * Event emitted when the user chooses to edit the facility.
         */
        this.onEdit = new core_1.EventEmitter();
    }
    set facility(value) {
        this._facility = value;
        this.resetRegistredBeds();
        this.resetSupportedResidentsThreshold();
        this.resetNumberOfUnits();
    }
    get facility() {
        return this._facility;
    }
    /**
     * Emits the @see onEdit event.
     */
    edit() {
        var _a;
        (_a = this.onEdit) === null || _a === void 0 ? void 0 : _a.emit(this.facility);
    }
    resetRegistredBeds() {
        if (this.facility && this.facility.registeredBedsList && this.facility.registeredBedsList.length > 0) {
            this.registeredBeds = Number.parseInt(this.facility.registeredBedsList[0].value);
            this.registeredBedsEffectiveDate = this.facility.registeredBedsList[0].startDate;
        }
        else if (this.facility) {
            this.registeredBeds = 0;
            this.registeredBedsEffectiveDate = null;
        }
        else {
            this.registeredBeds = null;
            this.registeredBedsEffectiveDate = null;
        }
    }
    resetSupportedResidentsThreshold() {
        if (this.facility && this.facility.supportedResidentsThresholdList && this.facility.supportedResidentsThresholdList.length > 0) {
            this.supportedResidentsThreshold = Number.parseFloat(this.facility.supportedResidentsThresholdList[0].value);
            this.supportedResidentsThresholdEffectiveDate = this.facility.supportedResidentsThresholdList[0].startDate;
        }
        else if (this.facility) {
            this.supportedResidentsThreshold = 0;
            this.supportedResidentsThresholdEffectiveDate = null;
        }
        else {
            this.supportedResidentsThreshold = null;
            this.supportedResidentsThresholdEffectiveDate = null;
        }
    }
    resetNumberOfUnits() {
        if (this.facility && this.facility.numberOfUnitsList && this.facility.numberOfUnitsList.length > 0) {
            this.numberOfUnits = Number.parseInt(this.facility.numberOfUnitsList[0].value);
            this.numberOfUnitsEffectiveDate = this.facility.numberOfUnitsList[0].startDate;
        }
        else if (this.facility) {
            this.numberOfUnits = 0;
            this.numberOfUnitsEffectiveDate = null;
        }
        else {
            this.numberOfUnits = null;
            this.numberOfUnitsEffectiveDate = null;
        }
    }
}
exports.FacilityDetailsViewTabComponent = FacilityDetailsViewTabComponent;
FacilityDetailsViewTabComponent.ɵfac = function FacilityDetailsViewTabComponent_Factory(t) { return new (t || FacilityDetailsViewTabComponent)(); };
FacilityDetailsViewTabComponent.ɵcmp = i0.ɵɵdefineComponent({ type: FacilityDetailsViewTabComponent, selectors: [["facility-details-view-tab"]], inputs: { facility: "facility" }, outputs: { onEdit: "onEdit" }, decls: 63, vars: 11, consts: [[1, "facility-details-tab", "vertical-tab"], [1, "panel-body"], [1, "form-section"], [1, "row", "space-below-label"], [1, "col-xs-5"], [1, "required-field"], [4, "ngIf"], ["data-automation", "agedCareServiceName", 1, "col-xs-4"], [1, "row"], [1, "sub-header-locations"], [1, "optional"], [1, "col-xs-6"], ["chipList", ""], [3, "selectable", "removable", 4, "ngFor", "ngForOf"], [1, "sub-header"], [1, "street1"], ["data-automation", "street1", 1, "col-xs-5"], ["data-automation", "street2", 1, "col-xs-5"], ["data-automation", "suburb", 1, "col-xs-4"], ["data-automation", "state", 1, "col-xs-3"], ["data-automation", "postCode", 1, "col-xs-3"], [1, "panel-footer"], [1, "pull-right"], ["data-automation", "edit-button", 1, "btn", "btn-primary", "btn-lg", "btn-inline-block-lg", 3, "click"], ["matTooltip", "National Approved Provider System", 1, "dna-info-icon", 3, "matTooltipPosition"], ["data-automation", "napsId", 1, "col-xs-4"], ["data-automation", "ediMinorCustomerID", 1, "col-xs-4"], ["data-automation", "archId", 1, "col-xs-4"], ["class", "row space-below-label", 4, "ngIf"], [1, "col-xs-4"], ["data-automation", "significantlyRefurbished", 1, "has-feedback"], [1, "dna-info-icon", 3, "dnaRPopover"], ["mmmDefinition", ""], ["data-automation", "facilityMMMClassification", 1, "col-xs-4"], [1, "col-xs-offset-5", "col-xs-6"], ["class", "text-x-small", 4, "ngIf"], [1, "col-xs-1", "margin-top-5"], ["href", "javascript:;", "data-automation", "supportedResidentsThreshold", 3, "dnaRPopover"], ["supportedResidentsThresholdList", ""], [1, "col-xs-3", "margin-left-20", "margin-top-5"], ["class", "view-value-note", "data-automation", "supportedResidentsThresholdEffectiveDate", 4, "ngIf"], [1, "col-xs-5", "space-below"], ["href", "javascript:;", "data-automation", "registeredBeds", 3, "dnaRPopover"], ["registeredBedsList", ""], ["class", "view-value-note", "data-automation", "registeredBedsEffectiveDate", 4, "ngIf"], ["data-automation", "region", 1, "col-xs-4"], [1, "mmm-popover", "popover-inner"], ["ng-bind", "uibTitle", "ng-if", "uibTitle", 1, "popover-title", "ng-binding", "ng-scope"], ["ng-bind", "content", 1, "popover-content", "ng-binding"], [1, "text-x-small"], ["href", "https://www.health.gov.au/resources/apps-and-tools/health-workforce-locator/health-workforce-locator"], [1, "popover-inner", "dna-r"], [1, "table"], [1, "align-right"], [4, "ngFor", "ngForOf"], ["data-automation", "supportedResidentsThresholdEffectiveDate", 1, "view-value-note"], ["data-automation", "registeredBedsEffectiveDate", 1, "view-value-note"], ["for", "careMinutesSupplement"], ["aria-label", "Care minutes supplement information", 1, "dna-info-icon", 3, "dnaRPopover"], ["careMinutesSupplement", ""], ["data-automation", "careMinutesSupplement", 1, "col-xs-4"], ["href", "javascript:;", "data-automation", "numberOfUnits", 3, "dnaRPopover"], ["numberOfUnitsList", ""], ["class", "view-value-note", "data-automation", "numberOfUnitsEffectiveDate", 4, "ngIf"], ["data-automation", "numberOfUnitsEffectiveDate", 1, "view-value-note"], [3, "selectable", "removable"]], template: function FacilityDetailsViewTabComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵelement(5, "i", 5);
        i0.ɵɵtemplate(6, FacilityDetailsViewTabComponent_label_6_Template, 2, 0, "label", 6);
        i0.ɵɵtemplate(7, FacilityDetailsViewTabComponent_label_7_Template, 2, 0, "label", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 7);
        i0.ɵɵtext(9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(10, FacilityDetailsViewTabComponent_div_10_Template, 74, 20, "div", 6);
        i0.ɵɵtemplate(11, FacilityDetailsViewTabComponent_div_11_Template, 13, 3, "div", 6);
        i0.ɵɵelementStart(12, "div", 8);
        i0.ɵɵelementStart(13, "div", 4);
        i0.ɵɵelementStart(14, "h3", 9);
        i0.ɵɵtext(15, "Locations ");
        i0.ɵɵelementStart(16, "span", 10);
        i0.ɵɵtext(17, "(optional)");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(18, "div", 11);
        i0.ɵɵelementStart(19, "mat-chip-list", null, 12);
        i0.ɵɵtemplate(21, FacilityDetailsViewTabComponent_mat_chip_21_Template, 2, 3, "mat-chip", 13);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(22, "div", 3);
        i0.ɵɵelementStart(23, "div", 4);
        i0.ɵɵelementStart(24, "h3", 14);
        i0.ɵɵtext(25, "Address ");
        i0.ɵɵelementStart(26, "span", 10);
        i0.ɵɵtext(27, "(optional)");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(28, "div", 3);
        i0.ɵɵelementStart(29, "div", 15);
        i0.ɵɵelementStart(30, "div", 4);
        i0.ɵɵelementStart(31, "label");
        i0.ɵɵtext(32, "Street line 1");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(33, "div", 16);
        i0.ɵɵtext(34);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(35, "div", 3);
        i0.ɵɵelementStart(36, "div", 4);
        i0.ɵɵelementStart(37, "label");
        i0.ɵɵtext(38, "Street line 2");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(39, "div", 17);
        i0.ɵɵtext(40);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(41, "div", 3);
        i0.ɵɵelementStart(42, "div", 4);
        i0.ɵɵelementStart(43, "label");
        i0.ɵɵtext(44, "Suburb or town");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(45, "div", 18);
        i0.ɵɵtext(46);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(47, "div", 3);
        i0.ɵɵelementStart(48, "div", 4);
        i0.ɵɵelementStart(49, "label");
        i0.ɵɵtext(50, "State");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(51, "div", 19);
        i0.ɵɵtext(52);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(53, "div", 3);
        i0.ɵɵelementStart(54, "div", 4);
        i0.ɵɵelementStart(55, "label");
        i0.ɵɵtext(56, "Postcode");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(57, "div", 20);
        i0.ɵɵtext(58);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(59, "div", 21);
        i0.ɵɵelementStart(60, "div", 22);
        i0.ɵɵelementStart(61, "button", 23);
        i0.ɵɵlistener("click", function FacilityDetailsViewTabComponent_Template_button_click_61_listener() { return ctx.edit(); });
        i0.ɵɵtext(62, "Edit");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngIf", ctx.facility.facilityType === "AgeCare");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.facility.facilityType === "IndependentLiving");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.facility.agedCareServiceName, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.facility.facilityType === "AgeCare");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.facility.facilityType === "IndependentLiving");
        i0.ɵɵadvance(10);
        i0.ɵɵproperty("ngForOf", ctx.facility.locations);
        i0.ɵɵadvance(13);
        i0.ɵɵtextInterpolate1(" ", ctx.facility.street1, " ");
        i0.ɵɵadvance(6);
        i0.ɵɵtextInterpolate1(" ", ctx.facility.street2, " ");
        i0.ɵɵadvance(6);
        i0.ɵɵtextInterpolate1(" ", ctx.facility.suburb, " ");
        i0.ɵɵadvance(6);
        i0.ɵɵtextInterpolate1(" ", ctx.facility.state, " ");
        i0.ɵɵadvance(6);
        i0.ɵɵtextInterpolate1(" ", ctx.facility.postCode, " ");
    } }, directives: [i1.NgIf, i2.MatChipList, i1.NgForOf, i3.MatTooltip, i4.DnaRPopoverDirective, i2.MatChip], pipes: [i1.DatePipe, i1.DecimalPipe, i1.CurrencyPipe], styles: [".facility-details-tab[_ngcontent-%COMP%]     .mat-chip-list-wrapper {\n  margin-top: 12px;\n  margin-bottom: 20px;\n}\n.facility-details-tab[_ngcontent-%COMP%]     .mat-chip-list-wrapper .mat-standard-chip {\n  border-radius: 4px;\n}\n.facility-details-tab[_ngcontent-%COMP%]     .icon.icon-info-fill {\n  height: 18px;\n  width: 18px;\n  vertical-align: text-bottom;\n}\n.facility-details-tab[_ngcontent-%COMP%]     label {\n  font-weight: 400;\n}\n.popover-inner[_ngcontent-%COMP%] {\n  background: #ffffff;\n  box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.3);\n}\n.popover-inner[_ngcontent-%COMP%]   .table[_ngcontent-%COMP%] {\n  border-right: 2px solid var(--neutrals-n-6-divider, #D2D2D2);\n  border-left: 2px solid var(--neutrals-n-6-divider, #D2D2D2);\n}\n.popover-inner.mmm-popover[_ngcontent-%COMP%] {\n  width: 275px;\n}"] });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(FacilityDetailsViewTabComponent, [{
        type: core_1.Component,
        args: [{
                selector: 'facility-details-view-tab',
                styleUrls: ['./facility-details-view-tab.component.less'],
                templateUrl: './facility-details-view-tab.component.html'
            }]
    }], function () { return []; }, { facility: [{
            type: core_1.Input
        }], onEdit: [{
            type: core_1.Output
        }] }); })();
